import React from 'react';
import { Platform } from 'react-native';

import { VFInput, VFButton } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import PropTypes from 'prop-types';

import { Images, getThemeColors as getLoginThemeColors } from '../../../Themes';
import LoginTestKeys from '../../../Utils/LoginTestKeys';

import styles from './LoginForm.Styles';

function LoginForm({
  phone,
  isValid,
  showErrorBox,
  isSendingSms,
  loginDisabled,
  emailOrPhoneRef,
  onPhoneChanged,
  maxLength,
  onSubmit,
  theme,
}) {
  const loginColors = getLoginThemeColors(theme.name);
  return (
    <>
      <VFInput
        fontSize={18.7}
        value={phone}
        fieldRef={emailOrPhoneRef}
        rightIconName={Images.ic_info_circle}
        label="register_phone_number_hint"
        leftIconName={Images.ic_mobile}
        keyboardType={'phone-pad'}
        containerStyle={styles.inputStyle}
        labelTextStyle={styles.label}
        baseColor={
          !isValid || showErrorBox ? loginColors.textInput.error : loginColors.textInput.baseColor
        }
        tintColor={
          !isValid || showErrorBox ? loginColors.textInput.error : loginColors.textInput.tintColor
        }
        textColor={loginColors.textInput.textColor}
        selectionColor={
          Platform.OS === 'ios'
            ? loginColors.textInput.selectionColor.ios
            : loginColors.textInput.selectionColor.android
        }
        showHelperText={!isValid}
        helperText={!isValid ? 'soft_login_add_valid_phone_number' : 'soft_login_helper_hint'}
        helperTextColor={
          !isValid || showErrorBox
            ? loginColors.textInput.error
            : loginColors.textInput.helperTextColor
        }
        isValid={isValid}
        onChangeText={onPhoneChanged}
        maxLength={maxLength}
        inputAccessibilityLabel={LoginTestKeys.loginPhoneTxt}
        helperAccessibilityLabel={LoginTestKeys.textInputError}
        testID={LoginTestKeys.loginPhoneNumberInputText}
        containerTestID={LoginTestKeys.loginByPhoneText}
      />
      <VFButton
        testID={LoginTestKeys.loginFormNextButton}
        title="soft_login_next_label"
        disabled={isSendingSms || loginDisabled}
        disabledStyle={styles.disabledBUttonStyle(theme)}
        disabledTextStyle={styles.disabledTextStyle(theme)}
        style={styles.button}
        onPress={onSubmit}
        type="primary"
        textAccessibilityLabel={LoginTestKeys.loginFormNextButton}
        accessible={false}
      />
    </>
  );
}

LoginForm.defaultProps = {
  theme: LightThemeColors,
};

LoginForm.propTypes = {
  phone: PropTypes.string,
  isValid: PropTypes.bool,
  showErrorBox: PropTypes.bool,
  isSendingSms: PropTypes.bool,
  loginDisabled: PropTypes.bool,
  emailOrPhoneRef: PropTypes.object,
  onPhoneChanged: PropTypes.func,
  maxLength: PropTypes.number,
  onSubmit: PropTypes.func,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default withTheme(LoginForm);
